import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getToken } from 'utils/auth';
import DashboardLayout from './DashboardLayout';

export default function ProtectedRoute({ children }) {
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const token = getToken();
        if (!token) {
            setIsLoading(false);
            navigate('/login', { replace: true });
            return;
        }
        setIsAuthenticated(true);
        setIsLoading(false);
    }, [navigate]);

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return null;
    }

    return <DashboardLayout>{children}</DashboardLayout>;
}
